// Bundle Builder JavaScript
// ============================================
// Configuration & Constants
// ============================================

const BUNDLE_CONFIG = {
  JUDGEME: {
    shopDomain: 'supergreenshempco.myshopify.com',
    apiToken: 'VHBjl2w1CZTS_xGUKAZlJ2WqXhk',
    PER_PAGE: 5
  },
  NOTIFICATION_DURATION: 3000,
  PROGRESS_CHECK_DELAY: 100,
  SCROLL_THRESHOLD: 2,
  SELECTORS: {
    bundleCard: '.bundle-card',
    qtyDisplay: '.qty-display',
    qtyControls: '.qty-controls',
    addBtn: '.bundle-modal-add-btn',
    qtyPlus: '.qty-plus',
    qtyMinus: '.qty-minus',
    bundleContainer: '.bundle-builder-container',
    bundleGrid: '.bundle-grid',
    bundleQty: '.bundle-qty',
    qtyBtn: '.qty-btn',
    bundleRemoveItem: '.bundle-remove-item'
  },
  ELEMENTS: {
    bundleNotification: 'bundle-notification',
    bundleNotificationText: 'bundle-notification-text',
    bundleProgressFill: 'bundle-progress-fill',
    bundleTotalItems: 'bundle-total-items',
    bundleDiscountLabel: 'bundle-discount-label',
    bundleItemsList: 'bundle-items-list',
    bundleAddToCart: 'bundle-direct-checkout',
    bundleProductModal: 'bundle-product-modal',
    bundleModalClose: 'bundle-modal-close',
    bundleModalOverlay: '.bundle-modal-overlay',
    bundleModalJdgm: 'bundle-modal-jdgm',
    bundleModalTags: 'bundle-modal-tags',
    bundleModalTitle: 'bundle-modal-title',
    bundleModalPrice: 'bundle-modal-price',
    bundleModalSize: '#bundle-modal-size span',
    bundleModalDescription: 'bundle-modal-description',
    bundleModalMainImg: 'bundle-modal-main-img',
    bundleModalThumbnails: 'bundle-modal-thumbnails',
    bundleModalPrev: 'bundle-modal-prev',
    bundleModalNext: 'bundle-modal-next',
    bundleModalQtyPlus: 'bundle-modal-qty-plus',
    bundleModalQtyMinus: 'bundle-modal-qty-minus',
    bundleModalQtyDisplay: 'bundle-modal-qty-display',
    bundleModalAddBtn: 'bundle-modal-add-btn',
    totalSavingAmount: 'total-saving-amount'
  },
  STORAGE_KEY: 'bundle_data',
  DEFAULT_TIERS: {
    tier1Qty: 7,
    tier2Qty: 14,
    tier3Qty: 21,
    tier1Percent: 0,
    tier2Percent: 0,
    tier3Percent: 0,
    tier1Code: 'BUNDLE5',
    tier2Code: 'BUNDLE20',
    tier3Code: 'BUNDLE30',
    customTotalItems: 21,
    customDiscountPercent: 0,
    customDiscountCode: 'BUNDLE30'
  }
};

// ============================================
// State Management
// ============================================

let bundle = {};
let currentProductData = null;
let currentImageIndex = 0;
let modalQuantity = 1;
let scrollPosition = 0;

// ============================================
// Utility Functions
// ============================================

/**
 * Get bundle settings from data attributes
 */
function getBundleSettings() {
  const container = document.querySelector(BUNDLE_CONFIG.SELECTORS.bundleContainer);
  if (!container) return BUNDLE_CONFIG.DEFAULT_TIERS;

  const defaults = BUNDLE_CONFIG.DEFAULT_TIERS;
  
  // Check if customTotalItems is explicitly set in data attributes
  const customTotalItemsAttr = container.dataset.customTotalItems;
  const customTotalItems = customTotalItemsAttr !== undefined && customTotalItemsAttr !== '' 
    ? parseInt(customTotalItemsAttr) 
    : null;
  
  return {
    tier1Qty: parseInt(container.dataset.tier1Qty) || defaults.tier1Qty,
    tier2Qty: parseInt(container.dataset.tier2Qty) || defaults.tier2Qty,
    tier3Qty: parseInt(container.dataset.tier3Qty) || defaults.tier3Qty,
    tier1Percent: parseInt(container.dataset.tier1Percent) || defaults.tier1Percent,
    tier2Percent: parseInt(container.dataset.tier2Percent) || defaults.tier2Percent,
    tier3Percent: parseInt(container.dataset.tier3Percent) || defaults.tier3Percent,
    tier1Code: container.dataset.tier1Code || defaults.tier1Code,
    tier2Code: container.dataset.tier2Code || defaults.tier2Code,
    tier3Code: container.dataset.tier3Code || defaults.tier3Code,
    customTotalItems: customTotalItems !== null && !isNaN(customTotalItems) ? customTotalItems : defaults.customTotalItems,
    customDiscountPercent: parseInt(container.dataset.customDiscountPercent) || defaults.customDiscountPercent,
    customDiscountCode: container.dataset.customDiscountCode || defaults.customDiscountCode
  };
}

/**
 * Extract discount code from URL path (e.g., /discount/BOGO50OUNCE)
 */
function getDiscountCodeFromURL() {
  const pathMatch = window.location.pathname.match(/\/discount\/([A-Z0-9]+)/i);
  if (pathMatch && pathMatch[1]) {
    return pathMatch[1];
  }
  return null;
}

/**
 * Handles the reveal of the sidebar on scroll
 */
function initializeSidebarReveal() {
  const sidebar = document.querySelector('.bundle-sidebar');
  if (!sidebar) return;

  window.addEventListener('scroll', () => {
    // Reveal sidebar after scrolling 300px
    if (window.scrollY > 300) {
      sidebar.classList.add('is-visible');
    } else {
      // Optional: Remove if you want it to hide again when scrolling back to top
      sidebar.classList.remove('is-visible');
    }
  }, { passive: true });
}

/**
 * Show notification message
 */
function showNotification(message, type = 'error') {
  const notification = document.getElementById(BUNDLE_CONFIG.ELEMENTS.bundleNotification);
  const notificationText = document.getElementById(BUNDLE_CONFIG.ELEMENTS.bundleNotificationText);

  if (!notification || !notificationText) return;

  notificationText.textContent = message;
  notification.className = `bundle-notification ${type}`;
  notification.classList.add('show');

  setTimeout(() => {
    notification.classList.remove('show');
  }, BUNDLE_CONFIG.NOTIFICATION_DURATION);
}

/**
 * Save bundle to localStorage
 */
function saveBundle() {
  try {
    localStorage.setItem(BUNDLE_CONFIG.STORAGE_KEY, JSON.stringify(bundle));
  } catch (error) {
    console.error('Error saving bundle to localStorage:', error);
  }
}

/**
 * Get current total quantity in bundle
 */
function getCurrentTotal() {
  let total = 0;
  if (bundle && typeof bundle === 'object' && !Array.isArray(bundle)) {
    Object.keys(bundle).forEach(key => {
      const qty = parseInt(bundle[key]);
      if (!isNaN(qty) && qty > 0) {
        total += qty;
      }
    });
  }
  return total;
}

/**
 * Check if more items can be added to bundle
 */
function canAddMoreItems(quantityToAdd = 1) {
  const settings = getBundleSettings();
  const currentTotal = getCurrentTotal();
  const maxItems = settings.customTotalItems || settings.tier3Qty;
  return (currentTotal + quantityToAdd) <= maxItems;
}

/**
 * Get card elements for a bundle card
 */
function getCardElements(card) {
  return {
    qtyDisplay: card.querySelector(BUNDLE_CONFIG.SELECTORS.qtyDisplay),
    qtyControls: card.querySelector(BUNDLE_CONFIG.SELECTORS.qtyControls),
    addBtn: card.querySelector(BUNDLE_CONFIG.SELECTORS.addBtn)
  };
}

/**
 * Update single card UI based on quantity
 */
function updateCardUI(card, qty) {
  const elements = getCardElements(card);
  if (!elements.qtyDisplay || !elements.qtyControls || !elements.addBtn) return;

  if (qty > 0) {
    elements.qtyDisplay.textContent = qty;
    elements.qtyDisplay.style.display = 'flex';
    elements.qtyControls.style.display = 'flex';
    elements.addBtn.style.display = 'none';
  } else {
    elements.qtyDisplay.style.display = 'none';
    elements.qtyControls.style.display = 'none';
    elements.addBtn.style.display = 'block';
  }
}

/**
 * Sync all bundle cards UI
 */
function syncBundleCardUI() {
  document.querySelectorAll(BUNDLE_CONFIG.SELECTORS.bundleCard).forEach(card => {
    const variantId = card.dataset.variantId;
    const qty = bundle[variantId] || 0;
    updateCardUI(card, qty);
  });
}

/**
 * Update card UI for specific variant ID
 */
function updateCardUIByVariantId(variantId) {
  document.querySelectorAll(BUNDLE_CONFIG.SELECTORS.bundleCard).forEach(card => {
    if (card.dataset.variantId === variantId) {
      const qty = bundle[variantId] || 0;
      updateCardUI(card, qty);
    }
  });
}

// ============================================
// Bundle Data Management
// ============================================

/**
 * Clean and validate bundle data
 */
function cleanBundleData(bundleData) {
  if (!bundleData || typeof bundleData !== 'object' || Array.isArray(bundleData)) {
    return {};
  }

  const cleaned = {};
  let hasValidData = false;

  Object.keys(bundleData).forEach(key => {
    const qty = parseInt(bundleData[key]);
    if (!isNaN(qty) && qty > 0) {
      cleaned[key] = qty;
      hasValidData = true;
    }
  });

  return hasValidData ? cleaned : {};
}

/**
 * Load bundle from localStorage
 */
function loadBundle() {
  const saved = localStorage.getItem(BUNDLE_CONFIG.STORAGE_KEY);

  if (saved) {
    try {
      const parsed = JSON.parse(saved);
      bundle = cleanBundleData(parsed);

      if (Object.keys(bundle).length === 0) {
        localStorage.removeItem(BUNDLE_CONFIG.STORAGE_KEY);
      } else {
        saveBundle();
      }
    } catch (e) {
      console.error('Error loading bundle:', e);
      bundle = {};
      localStorage.removeItem(BUNDLE_CONFIG.STORAGE_KEY);
    }
  } else {
    bundle = {};
  }

  syncBundleCardUI();
  updateBundleUI();
}

// ============================================
// Bundle Quantity Operations
// ============================================

/**
 * Add item to bundle
 */
function addToBundle(variantId, quantity = 1) {
  if (!canAddMoreItems(quantity)) {
    const settings = getBundleSettings();
    const maxItems = settings.customTotalItems || settings.tier3Qty;
    showNotification(`You can only add up to ${maxItems} items to your bundle.`, 'error');
    return false;
  }

  bundle[variantId] = (bundle[variantId] || 0) + quantity;
  saveBundle();
  updateCardUIByVariantId(variantId);
  updateBundleUI();
  return true;
}

/**
 * Remove item from bundle
 */
function removeFromBundle(variantId, quantity = 1) {
  if (!bundle[variantId] || bundle[variantId] <= 0) return false;

  bundle[variantId] = bundle[variantId] - quantity;

  if (bundle[variantId] <= 0) {
    delete bundle[variantId];
  }

  saveBundle();
  updateCardUIByVariantId(variantId);
  updateBundleUI();
  return true;
}

/**
 * Increment quantity for a variant
 */
function incrementQuantity(variantId) {
  return addToBundle(variantId, 1);
}

/**
 * Decrement quantity for a variant
 */
function decrementQuantity(variantId) {
  return removeFromBundle(variantId, 1);
}

// ============================================
// Judge.me Integration
// ============================================

/**
 * Fetch Judge.me widget data for a product
 */
async function fetchJudgeMeWidget(productId) {
  try {
    const url = `https://judge.me/api/v1/widgets/product_review?api_token=${BUNDLE_CONFIG.JUDGEME.apiToken}&shop_domain=${BUNDLE_CONFIG.JUDGEME.shopDomain}&external_id=${productId}&per_page=${BUNDLE_CONFIG.JUDGEME.PER_PAGE}`;
    const response = await fetch(url);

    if (response.ok) {
      return await response.json();
    }
  } catch (error) {
    console.log('Error fetching Judge.me widget:', error);
  }
  return null;
}

/**
 * Generate stars HTML for rating
 */
function generateStarsHTML(rating) {
  let starsHtml = '';
  for (let i = 1; i <= 5; i++) {
    if (i <= Math.floor(rating)) {
      starsHtml += '<span class="jdgm-star jdgm--on"></span>';
    } else if (i - 0.5 <= rating) {
      starsHtml += '<span class="jdgm-star jdgm--half"></span>';
    } else {
      starsHtml += '<span class="jdgm-star jdgm--off"></span>';
    }
  }
  return starsHtml;
}

/**
 * Render Judge.me badge in modal
 */
async function renderJudgeMeBadge(productId) {
  const container = document.getElementById(BUNDLE_CONFIG.ELEMENTS.bundleModalJdgm);
  if (!container) return;

  container.innerHTML = '<span class="jdgm-loading">Loading reviews...</span>';

  try {
    const data = await fetchJudgeMeWidget(productId);

    if (data && data.widget) {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = data.widget;
      const widgetEl = tempDiv.querySelector('.jdgm-rev-widg');

      if (widgetEl) {
        const avgRating = parseFloat(widgetEl.getAttribute('data-average-rating')) || 0;
        const reviewCount = parseInt(widgetEl.getAttribute('data-number-of-reviews')) || 0;
        const summaryEl = widgetEl.querySelector('.jdgm-rev-widg__summary');

        if (summaryEl) {
          const summaryClone = summaryEl.cloneNode(true);
          container.innerHTML = `
            <div class="jdgm-prev-badge" data-average-rating="${avgRating.toFixed(2)}" data-number-of-reviews="${reviewCount}">
              ${summaryClone.outerHTML}
            </div>
          `;
        } else {
          const starsHtml = generateStarsHTML(avgRating);
          const badgeText = reviewCount === 0 ? 'No reviews' :
            reviewCount === 1 ? '1 review' :
              `Based on ${reviewCount} reviews`;

          container.innerHTML = `
            <div class="jdgm-prev-badge" data-average-rating="${avgRating.toFixed(2)}" data-number-of-reviews="${reviewCount}">
              <div class="jdgm-rev-widg__summary">
                <div class="jdgm-rev-widg__summary-stars" aria-label="Average rating is ${avgRating.toFixed(2)} stars" role="img">
                  ${starsHtml}
                </div>
                <div class="jdgm-rev-widg__summary-text">${badgeText}</div>
              </div>
            </div>
          `;
        }
      } else {
        container.innerHTML = `
          <div class="jdgm-prev-badge" data-average-rating="0" data-number-of-reviews="0">
            <div class="jdgm-rev-widg__summary">
              <div class="jdgm-rev-widg__summary-stars">
                <span class="jdgm-star jdgm--off"></span>
                <span class="jdgm-star jdgm--off"></span>
                <span class="jdgm-star jdgm--off"></span>
                <span class="jdgm-star jdgm--off"></span>
                <span class="jdgm-star jdgm--off"></span>
              </div>
              <div class="jdgm-rev-widg__summary-text">No reviews</div>
            </div>
          </div>
        `;
      }
    } else {
      container.innerHTML = '';
    }
  } catch (error) {
    console.log('Error rendering Judge.me badge:', error);
    container.innerHTML = '';
  }
}

// ============================================
// Product Modal Functions
// ============================================

/**
 * Fetch product details from API
 */
async function fetchProductDetails(productHandle) {
  try {
    const response = await fetch(`/products/${productHandle}.js`);
    if (!response.ok) {
      throw new Error('Failed to fetch product details');
    }
    return await response.json();
  } catch (error) {
    console.error('Error fetching product:', error);
    throw error;
  }
}

/**
 * Render product tags in modal
 */
function renderProductTags(productData) {
  const tagsContainer = document.getElementById(BUNDLE_CONFIG.ELEMENTS.bundleModalTags);
  if (!tagsContainer || !Array.isArray(productData.tags)) return;

  const tags = productData.tags.map(tag => tag.toLowerCase());
  let html = "";

  const tagConfigs = {
    hybrid: { class: "new-hbd hmp-cst", label: "Hybrid" },
    indica: { class: "new-inc", label: "Indica" },
    sativa: { class: "new-rlf new-hmp-cst", label: "Sativa" }
  };

  const tagConfig = tagConfigs[tags.find(tag => tagConfigs[tag])];
  if (tagConfig) {
    html = `
      <div class="bundle-modal-tag">
        <p class="${tagConfig.class}" style="display:flex;align-items:center;gap:6px;">
          ${tagConfig.label}
        </p>
        <div class="bundle-card-price-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none">
            <rect y="7" width="4" height="12" rx="2" fill="#023A20"/>
            <rect x="7" y="3" width="4" height="16" rx="2" fill="#023A20"/>
            <rect x="14" width="4" height="19" rx="2" fill="#023A20"/>
          </svg>
          <span>high</span>
        </div>
      </div>
    `;
  }

  tagsContainer.innerHTML = html;
}

/**
 * Open product modal
 */
async function openProductModal(card) {
  const productHandle = card.dataset.productHandle;
  const variantId = card.dataset.variantId;
  const productId = card.dataset.productId;

  if (!productHandle) {
    console.error('Product handle not found');
    return;
  }

  const modal = document.getElementById(BUNDLE_CONFIG.ELEMENTS.bundleProductModal);
  if (!modal) return;

  // Store scroll position and lock body
  scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
  document.body.style.position = 'fixed';
  document.body.style.width = '100%';
  document.body.classList.add('bundle-modal-open');
  modal.classList.add('active');

  // Set header z-index to 0 when popup shows
  const header = document.querySelector('.section-header.shopify-section-group-header-group');
  if (header) {
    header.style.zIndex = '0';
    header.style.height = '80px';
  }

  requestAnimationFrame(() => {
    modal.scrollTop = 0;
  });

  try {
    const productData = await fetchProductDetails(productHandle);
    currentProductData = productData;

    // Render Judge.me reviews badge
    const reviewProductId = productId || productData.id;
    if (reviewProductId) {
      renderJudgeMeBadge(reviewProductId);
    }

    currentImageIndex = 0;
    modalQuantity = 1;
    const variant = productData.variants.find(v => v.id.toString() === variantId) || productData.variants[0];

    // Populate modal with product data
    const titleEl = document.getElementById(BUNDLE_CONFIG.ELEMENTS.bundleModalTitle);
    const priceEl = document.getElementById(BUNDLE_CONFIG.ELEMENTS.bundleModalPrice);
    const sizeEl = document.querySelector(BUNDLE_CONFIG.ELEMENTS.bundleModalSize);
    const descriptionEl = document.getElementById(BUNDLE_CONFIG.ELEMENTS.bundleModalDescription);
    const mainImgEl = document.getElementById(BUNDLE_CONFIG.ELEMENTS.bundleModalMainImg);

    if (titleEl) titleEl.textContent = productData.title;
    if (priceEl) priceEl.textContent = `$${(variant.price / 100).toFixed(2)}`;
    if (sizeEl) sizeEl.textContent = variant.title;
    if (descriptionEl) descriptionEl.innerHTML = productData.description || 'No description available';

    // Set images
    const images = productData.images && productData.images.length > 0
      ? productData.images
      : (productData.featured_image ? [productData.featured_image] : []);

    if (images.length > 0 && mainImgEl) {
      mainImgEl.src = images[0];
      mainImgEl.alt = productData.title;
    }

    // Populate thumbnails
    const thumbnailsContainer = document.getElementById(BUNDLE_CONFIG.ELEMENTS.bundleModalThumbnails);
    if (thumbnailsContainer) {
      thumbnailsContainer.innerHTML = '';

      if (images.length > 1) {
        images.forEach((img, index) => {
          const thumbnail = document.createElement('div');
          thumbnail.className = `bundle-modal-thumbnail ${index === 0 ? 'active' : ''}`;
          thumbnail.innerHTML = `<img src="${img}" alt="${productData.title}" width="80" height="80">`;
          thumbnail.addEventListener('click', () => {
            currentImageIndex = index;
            updateModalImage();
          });
          thumbnailsContainer.appendChild(thumbnail);
        });
      }
    }

    // Update navigation button visibility
    const prevBtn = document.getElementById(BUNDLE_CONFIG.ELEMENTS.bundleModalPrev);
    const nextBtn = document.getElementById(BUNDLE_CONFIG.ELEMENTS.bundleModalNext);
    if (prevBtn) prevBtn.style.display = images.length > 1 ? 'flex' : 'none';
    if (nextBtn) nextBtn.style.display = images.length > 1 ? 'flex' : 'none';

    // Sync modal quantity with bundle quantity
    const currentQty = bundle[variantId] || 0;
    modalQuantity = currentQty > 0 ? currentQty : 1;
    const qtyDisplayEl = document.getElementById(BUNDLE_CONFIG.ELEMENTS.bundleModalQtyDisplay);
    if (qtyDisplayEl) qtyDisplayEl.textContent = modalQuantity;

    // Store variant ID for add to cart
    modal.dataset.variantId = variant.id;

    renderProductTags(productData);

  } catch (error) {
    console.error('Error loading product:', error);
    showNotification('Failed to load product details. Please try again.', 'error');
    closeProductModal();
  }
}

/**
 * Close product modal
 */
function closeProductModal() {
  const modal = document.getElementById(BUNDLE_CONFIG.ELEMENTS.bundleProductModal);
  if (modal) {
    modal.classList.remove('active');
    document.body.classList.remove('bundle-modal-open');
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    window.scrollTo(0, scrollPosition);
  }

  // Set header z-index back to 3 when popup closes
  const header = document.querySelector('.section-header.shopify-section-group-header-group');
  if (header) {
    header.style.zIndex = '3';
    header.style.height = '';
  }

  currentProductData = null;
  currentImageIndex = 0;
  modalQuantity = 1;
  scrollPosition = 0;
}

/**
 * Update modal image display
 */
function updateModalImage() {
  if (!currentProductData || !currentProductData.images) return;

  const images = currentProductData.images;
  if (images.length === 0) return;

  const mainImgEl = document.getElementById(BUNDLE_CONFIG.ELEMENTS.bundleModalMainImg);
  if (mainImgEl) mainImgEl.src = images[currentImageIndex];

  // Update thumbnail active state
  document.querySelectorAll('.bundle-modal-thumbnail').forEach((thumb, index) => {
    thumb.classList.toggle('active', index === currentImageIndex);
  });

  // Show/hide navigation buttons
  const prevBtn = document.getElementById(BUNDLE_CONFIG.ELEMENTS.bundleModalPrev);
  const nextBtn = document.getElementById(BUNDLE_CONFIG.ELEMENTS.bundleModalNext);
  const displayValue = images.length > 1 ? 'flex' : 'none';
  if (prevBtn) prevBtn.style.display = displayValue;
  if (nextBtn) nextBtn.style.display = displayValue;
}

// ============================================
// Bundle UI Updates
// ============================================

/**
 * Calculate discount percentage based on total
 */
function calculateDiscountPercent(total) {
  const settings = getBundleSettings();
  // Use custom total items if set, otherwise fall back to tier system
  if (settings.customTotalItems && total >= settings.customTotalItems) {
    return settings.customDiscountPercent;
  }
  // Fall back to tier system for backward compatibility
  if (total >= settings.tier3Qty) return settings.tier3Percent;
  if (total >= settings.tier2Qty) return settings.tier2Percent;
  if (total >= settings.tier1Qty) return settings.tier1Percent;
  return 0;
}

/**
 * Calculate and update progress bar
 */
function updateProgressBar(total) {
  const settings = getBundleSettings();

  const t1 = settings.tier1Qty;
  const t2 = settings.tier2Qty;
  const t3 = settings.tier3Qty;

  const bar = document.querySelector('.bundle-progress-bar');
  const fill = document.getElementById(BUNDLE_CONFIG.ELEMENTS.bundleProgressFill);
  const boxes = document.querySelectorAll('.bundle-progress-boxee .box');

  if (!bar || !fill || boxes.length === 0) return;

  const barRect = bar.getBoundingClientRect();

  // Get exact pixel positions of boxes relative to bar
  const boxPositions = Array.from(boxes).map(box => {
    const rect = box.getBoundingClientRect();
    return rect.left - barRect.left + rect.width / 2;
  });

  let targetWidth = 0;

  if (total < t1) {
    targetWidth = (total / t1) * boxPositions[0];
  }
  else if (total < t2) {
    targetWidth = boxPositions[0] +
      ((total - t1) / (t2 - t1)) * (boxPositions[1] - boxPositions[0]);
  }
  else if (total < t3) {
    targetWidth = boxPositions[1] +
      ((total - t2) / (t3 - t2)) * (boxPositions[2] - boxPositions[1]);
  }
  else {
    targetWidth = boxPositions[2];
  }

  const percent = (targetWidth / barRect.width) * 100;
  fill.style.width = percent + '%';
}




/**
 * Build bundle items array from bundle data
 */
function buildBundleItemsArray() {
  const items = [];
  document.querySelectorAll(BUNDLE_CONFIG.SELECTORS.bundleCard).forEach(card => {
    const id = card.dataset.variantId;
    const qty = bundle[id] || 0;

    if (qty > 0) {
      for (let i = 0; i < qty; i++) {
        items.push({
          id: id,
          card: card,
          title: card.dataset.title,
          price: card.dataset.price,
          img: card.dataset.img
        });
      }
    }
  });
  return items;
}

/**
 * Render bundle items list
 */
function renderBundleItemsList(bundleItems, total) {
  const list = document.getElementById(BUNDLE_CONFIG.ELEMENTS.bundleItemsList);
  if (!list) return;

  const isEnabled = list?.dataset.enableSection === 'true';
  list.innerHTML = "";

  // Display filled items
  bundleItems.forEach(item => {
    list.innerHTML += `
  <div class="bundle-sidebar-item" data-variant-id="${item.id}">
    <div class="sidebar-img-container">
      <img src="${item.img}" class="sidebar-thumb">
    </div>
    <div class="sidebar-item-info">
      <div class="sidebar-item-title">${item.title}</div>
      <div class="sidebar-item-price">
        ${isEnabled ? '3.5 Grams' : '28 Grams'}
      </div>
    </div>
    <button class="sidebar-delete-btn bundle-remove-item" data-variant-id="${item.id}" aria-label="Remove item">×</button>
  </div>
`;
  });

  // Add empty slots
  const settings = getBundleSettings();
  const maxItems = settings.customTotalItems || settings.tier3Qty;
  const emptySlots = Math.max(0, maxItems - total);
  const isBundleFull = total >= maxItems;
  for (let i = 0; i < emptySlots; i++) {
    const emptySlot = document.createElement('div');
    emptySlot.className = 'bundle-sidebar-item-empty';
    if (isBundleFull) {
      emptySlot.style.opacity = '0.5';
      emptySlot.style.cursor = 'not-allowed';
      emptySlot.style.pointerEvents = 'none';
    }
    emptySlot.innerHTML = `
      <div class="sidebar-no-img-container">
        <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="sidebar-plus-icon">
          <path d="M12 5V19M5 12H19" stroke="#969696" stroke-width="2" stroke-linecap="round"/>
        </svg>
      </div>
      <div class="sidebar-item-info">
        <div class="sidebar-empty-text">SELECT A PRODUCT</div>
      </div>
    `;
    if (!isBundleFull) {
      emptySlot.addEventListener('click', () => {
        const firstCard = document.querySelector(BUNDLE_CONFIG.SELECTORS.bundleCard);
        if (firstCard) {
          openProductModal(firstCard);
        }
      });
    }
    list.appendChild(emptySlot);
  }
}

/**
 * Update cart button with pricing
 * Applies discount to the lowest price item only
 */
// =================== OLD CODE =============================
//  function updateCartButton(bundleItems, discountPercent) {
//   const cartBtn = document.getElementById(BUNDLE_CONFIG.ELEMENTS.bundleAddToCart);
//   if (!cartBtn) return;

//   let totalPrice = 0;
//   let lowestPrice = Infinity;
//   let lowestPriceIndex = -1;
  
//   bundleItems.forEach((item, index) => {
//     const priceRaw = parseFloat(item.card.dataset.priceRaw || 0);
//     totalPrice += priceRaw;
    
//     // Find the lowest price item
//     if (priceRaw < lowestPrice) {
//       lowestPrice = priceRaw;
//       lowestPriceIndex = index;
//     }
//   });

//   // Apply discount only to the lowest price item
//   let savings = 0;
//   if (lowestPriceIndex >= 0 && lowestPrice < Infinity && discountPercent > 0) {
//     savings = lowestPrice * (discountPercent / 100);
//   }
//   const finalPrice = totalPrice - savings;

//   // Update savings display
//   const savingEl = document.getElementById(BUNDLE_CONFIG.ELEMENTS.totalSavingAmount);
//   if (savingEl) {
//     savingEl.textContent = `$${savings.toFixed(2)}`;
//   }

//   if (discountPercent > 0) {
//     cartBtn.innerHTML = `
//       BUILD MY BUNDLE | CART 
//       <span style="text-decoration: line-through; opacity: 0.6; margin-right: 6px;">
//         $${totalPrice.toFixed(2)}
//       </span>
//       <strong>$${finalPrice.toFixed(2)}</strong>
//     `;
//   } else {
//     cartBtn.textContent = `BUILD MY BUNDLE | CART $${totalPrice.toFixed(2)}`;
//   }
// }
/**
 * Update cart button with pricing
 * Shows strike-through original price and discounted final price
 */
function updateCartButton(bundleItems, discountPercent) {
  const cartBtn = document.getElementById(BUNDLE_CONFIG.ELEMENTS.bundleAddToCart);
  if (!cartBtn) return;

  let totalPrice = 0;
  
  // Calculate the raw total of all items in the bundle
  bundleItems.forEach((item) => {
    // Prefer priceCents (divide by 100) for accurate decimal handling, fallback to priceRaw
    let priceRaw = 0;
    if (item.card.dataset.priceCents) {
      const priceCents = parseFloat(item.card.dataset.priceCents);
      priceRaw = !isNaN(priceCents) ? priceCents / 100 : 0;
    } else {
      priceRaw = parseFloat(item.card.dataset.priceRaw || 0);
    }
    totalPrice += priceRaw;
  });

  let totalSavings = 0;
  let finalPrice = totalPrice;

  if (totalPrice > 0 && discountPercent > 0) {
    totalSavings = totalPrice * (discountPercent / 100);
    
    // Calculate raw discounted price
    const rawFinalPrice = totalPrice - totalSavings;
    
    // FORCE ROUND UP (Ceiling) logic: 
    // If result is 44.081 or 44.082 -> becomes 44.09
    finalPrice = Math.ceil(rawFinalPrice * 100) / 100;
  }
  
  // Update the "Total Savings: $0.00" display in the sidebar
  const savingEl = document.getElementById(BUNDLE_CONFIG.ELEMENTS.totalSavingAmount);
  if (savingEl) {
    savingEl.textContent = `$${totalSavings.toFixed(2)}`;
  }

  // Update the Button Text
  if (discountPercent > 0) {
    cartBtn.innerHTML = `
      BUILD MY BUNDLE &nbsp;|&nbsp; 
      <span class="bundle-strike-price">$${totalPrice.toFixed(2)}</span>
      <span class="bundle-final-price">$${finalPrice.toFixed(2)}</span>
    `;
  } else {
    cartBtn.innerHTML = `BUILD MY BUNDLE &nbsp;|&nbsp; CART $${totalPrice.toFixed(2)}`;
  }
}


/**
 * Validate and clean bundle against valid variant IDs
 */
function validateBundleAgainstCards() {
  const validVariantIds = new Set();
  document.querySelectorAll(BUNDLE_CONFIG.SELECTORS.bundleCard).forEach(card => {
    const variantId = card.dataset.variantId;
    if (variantId) {
      validVariantIds.add(variantId);
    }
  });

  let cleanedBundle = false;
  if (bundle && typeof bundle === 'object' && !Array.isArray(bundle)) {
    Object.keys(bundle).forEach(key => {
      const qty = parseInt(bundle[key]);
      if (isNaN(qty) || qty <= 0 || !validVariantIds.has(key)) {
        delete bundle[key];
        cleanedBundle = true;
      }
    });
  }

  if (cleanedBundle) {
    if (Object.keys(bundle).length === 0) {
      localStorage.removeItem(BUNDLE_CONFIG.STORAGE_KEY);
    } else {
      saveBundle();
    }
  }
}

/**
 * Main function to update bundle UI
 */
function updateBundleUI() {
  // Ensure bundle is an object
  if (!bundle || typeof bundle !== 'object' || Array.isArray(bundle)) {
    bundle = {};
  }

  // Validate bundle against actual product cards
  validateBundleAgainstCards();

  // Calculate total
  const total = getCurrentTotal();
  const discountPercent = calculateDiscountPercent(total);

  // Update total display
  const totalItemsEl = document.getElementById(BUNDLE_CONFIG.ELEMENTS.bundleTotalItems);
  const discountLabelEl = document.getElementById(BUNDLE_CONFIG.ELEMENTS.bundleDiscountLabel);
  if (totalItemsEl) totalItemsEl.innerText = total;
  if (discountLabelEl) discountLabelEl.innerText = discountPercent + "%";

  // Build and render items
  const bundleItems = buildBundleItemsArray();
  renderBundleItemsList(bundleItems, total);

  // Attach remove handlers
  attachRemoveItemHandlers();

  // Update progress bar
  updateProgressBar(total);

  // Update cart button
  updateCartButton(bundleItems, discountPercent);
}

/**
 * Attach event handlers to remove item buttons
 */
function attachRemoveItemHandlers() {
  document.querySelectorAll(BUNDLE_CONFIG.SELECTORS.bundleRemoveItem).forEach(btn => {
    // Remove existing listeners by cloning
    const newBtn = btn.cloneNode(true);
    btn.parentNode?.replaceChild(newBtn, btn);

    newBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      const variantId = newBtn.dataset.variantId;
      if (variantId) {
        removeFromBundle(variantId, 1);
      }
    });
  });
}

/**
 * Update modal quantity display
 */
function updateModalQuantityDisplay() {
  const qtyDisplayEl = document.getElementById(BUNDLE_CONFIG.ELEMENTS.bundleModalQtyDisplay);
  if (qtyDisplayEl) qtyDisplayEl.textContent = modalQuantity;
}

// ============================================
// Event Handlers & Initialization
// ============================================

/**
 * Initialize product modal event handlers
 */
function initializeProductModal() {
  // Card click handlers (excluding quantity buttons)
  document.querySelectorAll(BUNDLE_CONFIG.SELECTORS.bundleCard).forEach(card => {
    card.addEventListener('click', (e) => {
      const isQtyControl = e.target.closest(BUNDLE_CONFIG.SELECTORS.bundleQty) ||
        e.target.closest(BUNDLE_CONFIG.SELECTORS.qtyBtn) ||
        e.target.classList.contains('qty-btn') ||
        e.target.classList.contains('qty-minus') ||
        e.target.classList.contains('qty-plus') ||
        e.target.classList.contains('qty-display') ||
        e.target.closest(BUNDLE_CONFIG.SELECTORS.addBtn);

      if (!isQtyControl) {
        e.preventDefault();
        e.stopPropagation();
        openProductModal(card);
      }
    });
  });

  // Close modal handlers
  const closeBtn = document.getElementById(BUNDLE_CONFIG.ELEMENTS.bundleModalClose);
  const overlay = document.querySelector(BUNDLE_CONFIG.ELEMENTS.bundleModalOverlay);

  if (closeBtn) closeBtn.addEventListener('click', closeProductModal);
  if (overlay) overlay.addEventListener('click', closeProductModal);

  // Image navigation
  const prevBtn = document.getElementById(BUNDLE_CONFIG.ELEMENTS.bundleModalPrev);
  const nextBtn = document.getElementById(BUNDLE_CONFIG.ELEMENTS.bundleModalNext);

  if (prevBtn) {
    prevBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      if (currentProductData?.images) {
        const imagesLength = currentProductData.images.length;
        currentImageIndex = (currentImageIndex - 1 + imagesLength) % imagesLength;
        updateModalImage();
      }
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      if (currentProductData?.images) {
        currentImageIndex = (currentImageIndex + 1) % currentProductData.images.length;
        updateModalImage();
      }
    });
  }

  // Modal quantity controls
  const qtyPlus = document.getElementById(BUNDLE_CONFIG.ELEMENTS.bundleModalQtyPlus);
  const qtyMinus = document.getElementById(BUNDLE_CONFIG.ELEMENTS.bundleModalQtyMinus);

  if (qtyPlus) {
    qtyPlus.addEventListener('click', (e) => {
      e.stopPropagation();
      const modal = document.getElementById(BUNDLE_CONFIG.ELEMENTS.bundleProductModal);
      const variantId = modal ? modal.dataset.variantId : null;
      const currentItemQty = variantId ? (bundle[variantId] || 0) : 0;
      const settings = getBundleSettings();
      const currentTotal = getCurrentTotal();
      const newTotal = currentTotal - currentItemQty + (modalQuantity + 1);
      const maxItems = settings.customTotalItems || settings.tier3Qty;

      if (newTotal > maxItems) {
        showNotification(`You can only add up to ${maxItems} items to your bundle.`, 'error');
        return;
      }

      modalQuantity++;
      updateModalQuantityDisplay();
    });
  }

  if (qtyMinus) {
    qtyMinus.addEventListener('click', (e) => {
      e.stopPropagation();
      if (modalQuantity > 1) {
        modalQuantity--;
        updateModalQuantityDisplay();
      }
    });
  }

  // Add to bundle button (on cards)
  document.querySelectorAll(BUNDLE_CONFIG.SELECTORS.addBtn).forEach(btn => {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      const card = this.closest(BUNDLE_CONFIG.SELECTORS.bundleCard);
      if (!card) return;

      const variantId = card.dataset.variantId;
      if (!variantId) return;

      addToBundle(variantId, 1);
    });
  });

  // Add to Box button in modal
  const modalAddBtn = document.getElementById(BUNDLE_CONFIG.ELEMENTS.bundleModalAddBtn);
  if (modalAddBtn) {
    modalAddBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      const modal = document.getElementById(BUNDLE_CONFIG.ELEMENTS.bundleProductModal);
      const variantId = modal ? modal.dataset.variantId : null;

      if (!variantId) {
        showNotification('Product variant not found', 'error');
        return;
      }

      if (!canAddMoreItems(modalQuantity)) {
        const settings = getBundleSettings();
        const maxItems = settings.customTotalItems || settings.tier3Qty;
        showNotification(`You can only add up to ${maxItems} items to your bundle.`, 'error');
        return;
      }

      addToBundle(variantId, modalQuantity);
      closeProductModal();
    });
  }

  // Close on Escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      const modal = document.getElementById(BUNDLE_CONFIG.ELEMENTS.bundleProductModal);
      if (modal && modal.classList.contains('active')) {
        closeProductModal();
      }
    }
  });
}

/**
 * Initialize quantity button handlers
 */
function initializeQuantityButtons() {
  document.querySelectorAll(BUNDLE_CONFIG.SELECTORS.bundleCard).forEach(card => {
    const variantId = card.dataset.variantId;
    if (!variantId) return;

    const plusBtn = card.querySelector(BUNDLE_CONFIG.SELECTORS.qtyPlus);
    const minusBtn = card.querySelector(BUNDLE_CONFIG.SELECTORS.qtyMinus);

    if (plusBtn) {
      plusBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        incrementQuantity(variantId);
      });
    }

    if (minusBtn) {
      minusBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        decrementQuantity(variantId);
      });
    }
  });
}

/**
 * Find the cheapest product in the current bundle
 * Returns { variantId, price, title }
 */
function getCheapestProductInBundle() {
  let cheapest = null;
  let cheapestPrice = Infinity;

  Object.keys(bundle).forEach(variantId => {
    const card = document.querySelector(`[data-variant-id="${variantId}"]`);
    if (card) {
      // Prefer priceCents (divide by 100) for accurate decimal handling, fallback to priceRaw
      let price = 0;
      if (card.dataset.priceCents) {
        const priceCents = parseFloat(card.dataset.priceCents);
        price = !isNaN(priceCents) ? priceCents / 100 : 0;
      } else {
        price = parseFloat(card.dataset.priceRaw || 0);
      }
      if (price < cheapestPrice && price > 0) {
        cheapestPrice = price;
        cheapest = {
          variantId: Number(variantId),
          price: price,
          title: card.dataset.title || 'Product'
        };
      }
    }
  });

  return cheapest;
}

/**
 * Initialize add to cart handler
 */
function initializeAddToCart() {
  const addToCartBtn = document.getElementById(BUNDLE_CONFIG.ELEMENTS.bundleAddToCart);
  if (!addToCartBtn) return;

  addToCartBtn.addEventListener("click", async () => {
    // 1. Create items array
    const items = [];
    Object.keys(bundle).forEach(id => {
      const qty = bundle[id];
      for (let i = 0; i < qty; i++) {
        items.push({
          id: Number(id),
          quantity: 1
        });
      }
    });

    if (items.length === 0) {
      showNotification("Please add items to your bundle first", 'error');
      return;
    }

    // --- NEW LOGIC START ---
    
    // 2. Calculate Discount BEFORE adding to cart
    // We do this first so we can set the cookie before UpCart wakes up
    const total = getCurrentTotal(); 
    const settings = getBundleSettings();
    let discountCode = 'BUNDLESG26'; // Default fallback

    if (settings.tier3Code && total >= settings.tier3Qty) {
      discountCode = settings.tier3Code;
    } else if (settings.tier2Code && total >= settings.tier2Qty) {
      discountCode = settings.tier2Code;
    } else if (settings.tier1Code && total >= settings.tier1Qty) {
      discountCode = settings.tier1Code;
    }

    // 3. PRE-APPLY DISCOUNT
    // We await this so the cookie is 100% set before the cart gets items
    if (discountCode) {
      try {
        sessionStorage.setItem('bundleDiscountCode', discountCode);
        await fetch(`/discount/${discountCode}`);
        console.log(`Discount ${discountCode} pre-applied.`);
      } catch (err) {
        console.error('Error pre-applying discount:', err);
      }
    } else {
      sessionStorage.removeItem('bundleDiscountCode');
    }

    // --- NEW LOGIC END ---

    // 4. NOW Add items to cart
    // UpCart will detect this and open, but since we waited for step 3, 
    // the discount cookie is already there!
    const addResponse = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items })
    });

    if (!addResponse.ok) {
      const errorData = await addResponse.json().catch(() => ({}));
      showNotification(errorData.description || "Failed to add items to cart", 'error');
      return;
    }

    // 5. Update UI / Dispatch Events (Backup for non-UpCart themes)
    try {
      // We fetch the cart just to trigger any listeners
      const cartJson = await (await fetch('/cart.js')).json();
      document.dispatchEvent(new CustomEvent("cart:update", {
        detail: { cart: cartJson }
      }));
      
      // If UpCart is running, it handles the drawer. 
      // We just show a notification.
      const notificationMessage = discountCode 
        ? `Bundle added! Discount ${discountCode} applied.` 
        : "Bundle added to cart!";
      showNotification(notificationMessage, 'success');

    } catch (error) {
      console.error("Error updating cart:", error);
    }
  });
}

function setupDiscountCodeHandler() {
  const discountCode = sessionStorage.getItem('bundleDiscountCode');
  if (!discountCode) return;
  
  const cartDrawer = document.querySelector('cart-drawer');
  if (!cartDrawer) return;
  
  if (cartDrawer.dataset.bundleDiscountSetup === 'true') return;
  
  const setupHandler = () => {
    const checkoutBtn = cartDrawer.querySelector('#CartDrawer-Checkout, .cart__checkout-button, button[name="checkout"]');
    const cartForm = cartDrawer.querySelector('#CartDrawer-Form, form[action*="cart"]');
    
    if (checkoutBtn && !checkoutBtn.dataset.bundleDiscountHandler) {
      checkoutBtn.dataset.bundleDiscountHandler = 'true';
      
      checkoutBtn.addEventListener('click', function(e) {
        const storedCode = sessionStorage.getItem('bundleDiscountCode');
        if (storedCode) {
          e.preventDefault();
          e.stopPropagation();
          window.location.href = `/checkout?discount=${encodeURIComponent(storedCode)}`;
          return false;
        }
      }, true);
      
      if (cartForm && !cartForm.dataset.bundleDiscountHandler) {
        cartForm.dataset.bundleDiscountHandler = 'true';
        cartForm.addEventListener('submit', function(e) {
          const storedCode = sessionStorage.getItem('bundleDiscountCode');
          const isCheckoutSubmit = e.submitter && (
            e.submitter === checkoutBtn || 
            e.submitter.id === 'CartDrawer-Checkout' ||
            e.submitter.name === 'checkout' ||
            e.submitter.classList.contains('cart__checkout-button')
          );
          
          if (storedCode && isCheckoutSubmit) {
            e.preventDefault();
            e.stopPropagation();
            window.location.href = `/checkout?discount=${encodeURIComponent(storedCode)}`;
            return false;
          }
        }, true);
      }
    }
  };
  
  setupHandler();
  
  document.addEventListener('cart:update', () => {
    setTimeout(setupHandler, 100);
  }, { once: false });
  
  cartDrawer.dataset.bundleDiscountSetup = 'true';
}

/**
 * Filter products by strain type
 */
function filterProducts(filterType) {
  document.querySelectorAll(BUNDLE_CONFIG.SELECTORS.bundleCard).forEach(card => {
    const strain = card.dataset.strain || 'all';
    if (filterType === 'all' || strain === filterType) {
      card.classList.remove('hidden');
    } else {
      card.classList.add('hidden');
    }
  });
}

/**
 * Sort products
 */
function sortProducts(sortType) {
  const grid = document.querySelector(BUNDLE_CONFIG.SELECTORS.bundleGrid);
  if (!grid) return;

  const cards = Array.from(document.querySelectorAll(`${BUNDLE_CONFIG.SELECTORS.bundleCard}:not(.hidden)`));

  cards.sort((a, b) => {
    switch (sortType) {
      case 'price-low':
        const priceA = a.dataset.priceCents ? parseFloat(a.dataset.priceCents) / 100 : parseFloat(a.dataset.priceRaw || 0);
        const priceB = b.dataset.priceCents ? parseFloat(b.dataset.priceCents) / 100 : parseFloat(b.dataset.priceRaw || 0);
        return priceA - priceB;
      case 'price-high':
        const priceAHigh = a.dataset.priceCents ? parseFloat(a.dataset.priceCents) / 100 : parseFloat(a.dataset.priceRaw || 0);
        const priceBHigh = b.dataset.priceCents ? parseFloat(b.dataset.priceCents) / 100 : parseFloat(b.dataset.priceRaw || 0);
        return priceBHigh - priceAHigh;
      case 'name-asc':
        return (a.dataset.title || '').localeCompare(b.dataset.title || '');
      case 'best-selling':
      default:
        return 0; // Keep original order
    }
  });

  cards.forEach(card => grid.appendChild(card));
}

/**
 * Initialize filters and sort
 */
function initializeFiltersAndSort() {
  // Filter buttons
  const filterButtons = document.querySelectorAll('.bundle-filter-btn');
  filterButtons.forEach(btn => {
    btn.addEventListener('click', function () {
      filterButtons.forEach(b => b.classList.remove('active'));
      this.classList.add('active');
      const filterType = this.dataset.filter;
      filterProducts(filterType);

      const sortSelect = document.getElementById('bundle-sort-select');
      if (sortSelect) {
        sortProducts(sortSelect.value);
      }
    });
  });

  // Sort select
  const sortSelect = document.getElementById('bundle-sort-select');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      sortProducts(this.value);
    });
  }
}

/**
 * Initialize mobile bundle toggle
 */
function initializeMobileBundleToggle() {
  const dropBtn = document.querySelector(".mbl-drop");
  const imgClose = document.querySelector(".img-close");
  // const overlayContainer = document.querySelector('.overlay-contianer');

  function toggleBundle() {
    document.querySelector(".bundle-items-list")?.classList.toggle("show");
    // document.querySelector(".wraper-mobile-sidebar")?.classList.toggle("show");
    document.querySelector(".img-open")?.classList.toggle("hidden");
    document.querySelector(".img-close")?.classList.toggle("hidden");
    document.querySelector(".bottom-overlay")?.classList.toggle("show");
    //   if (overlayContainer) {
    //   overlayContainer.classList.toggle("show");
    // }
  }

  if (dropBtn) dropBtn.addEventListener("click", toggleBundle);
  if (imgClose) imgClose.addEventListener("click", toggleBundle);
}

/**
 * Handle scroll overlay visibility
 */
function handleScrollOverlay(element, overlay, threshold = BUNDLE_CONFIG.SCROLL_THRESHOLD) {
  if (!element || !overlay) return;

  element.addEventListener('scroll', () => {
    const { scrollTop, scrollHeight, clientHeight } = element;
    const isAtBottom = scrollTop + clientHeight >= scrollHeight - threshold;
    overlay.style.display = isAtBottom ? 'none' : '';
  });
}

/**
 * Initialize scroll overlays
 */
function initializeScrollOverlays() {
  const bundleList = document.querySelector('.bundle-items-list');
  const bottomOverlay = document.querySelector('.bottom-overlay');
  handleScrollOverlay(bundleList, bottomOverlay);

  const bundleModalList = document.querySelector(BUNDLE_CONFIG.ELEMENTS.bundleModalDescription);
  const paraOverlay = document.querySelector('.para-overlay');
  handleScrollOverlay(bundleModalList, paraOverlay);
}

// ============================================
// Initialization
// ============================================

// Initialize bundle on page load
loadBundle();
syncBundleCardUI();

// DOMContentLoaded initialization
document.addEventListener("DOMContentLoaded", function () {
  if (!bundle || typeof bundle !== 'object') {
    bundle = {};
  }

  // Initialize progress bar to 0% before loading bundle data
  const progressFill = document.getElementById(BUNDLE_CONFIG.ELEMENTS.bundleProgressFill);
  if (progressFill) {
    progressFill.removeAttribute('style');
    progressFill.style.width = "0%";
    progressFill.style.minWidth = "0%";
  }

  loadBundle();
  initializeProductModal();
  initializeQuantityButtons();
  initializeAddToCart();
  initializeFiltersAndSort();
  initializeMobileBundleToggle();
  initializeScrollOverlays();
  initializeSidebarReveal();
  
  if (sessionStorage.getItem('bundleDiscountCode')) {
    const checkCartDrawer = setInterval(() => {
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        clearInterval(checkCartDrawer);
        setupDiscountCodeHandler();
      }
    }, 100);
    
    setTimeout(() => clearInterval(checkCartDrawer), 5000);
  }

  // Double-check progress bar after a short delay
  setTimeout(() => {
    const progressFillCheck = document.getElementById(BUNDLE_CONFIG.ELEMENTS.bundleProgressFill);
    const totalCheck = getCurrentTotal();
    if (progressFillCheck && totalCheck === 0) {
      progressFillCheck.removeAttribute('style');
      progressFillCheck.style.width = "0%";
      progressFillCheck.style.minWidth = "0%";
    }
  }, BUNDLE_CONFIG.PROGRESS_CHECK_DELAY);
});
